window._define('modules/confirm', ['jquery', '_', 'app/core', 'utils/responsive', 'i18n'], function ($, _, core, responsive, __) {
    var $currentWin, confirmTemplate = _.template('<div class="popin popin--confirm">\
                <% if (title) { %>\
                    <h1><%= title %></h1>\
                <% } %>\
                <% if (icon) { %>\
                    <i class="<%= icon %> popin__icon"></i>\
                <% } %>\
                <p><%= text %></p>\
                <% if (doubleConfirm) { %>\
                    <label class="popin__checkConfirmContainer">\
                        <input class="popin__checkConfirm js-confirm-doubleCheck" type="checkbox"> <%= doubleConfirm %>\
                    </label>\
                <% } %>\
            </div>');

    function centerCurrentDialog() {
        $currentWin.parent('.ui-dialog').position({
            my: 'center',
            at: 'center',
            of: window,
        });
    }

    function onClickOutside(event) {
        if ($(event.target).is('.ui-widget-overlay')) {
            $currentWin.dialog('close');
        }
    }

    function onScrollResize(event) {
        if (event.type === 'mousewheel') {
            event.preventDefault();
        } else {
            centerCurrentDialog();
        }
    }

    function onOpen($element, buttonText, buttonWhenChecked, focusButton) {
        var $parent = $element.parents('.ui-dialog'), $cancelButton = $parent.find('.js-cancel-button'), $validateButton = $parent.find('.js-validate-button');

        $element.find('.js-confirm-doubleCheck').on('change', function () {
            $validateButton.text($(this).prop('checked') ? buttonWhenChecked : buttonText);
            $validateButton.html('<span class="ui-button-text">' + $validateButton.text() + '</span>');
        });

        if (focusButton === 'validate') {
            $validateButton.focus();
        } else {
            $cancelButton.focus();
        }
    }

    function alert(message, options) {
        if (!options) {
            options = {};
        }

        options.message = message;
        confirm(options);
    }

    function confirm(options) {
        var $element,
            element,
            dialogOptions,
            validOptions = [
                'message', 'textButton', 'cancelButton', 'textButtonCancel',
                'icon', 'title', 'doubleConfirm', 'doubleConfirmButton',
                'forceWidth', 'focusButton',
            ];

        // we passed an element where we can have some configuration in data attributes
        if (options.element) {
            $element = $(options.element);

            validOptions.forEach(function (option) {
                var optionValue;

                if ($element.data(option)) {
                    optionValue = $element.data(option);

                    // if a selector is passed, get the html
                    if (option === 'message' && optionValue.match(/^(\.|#)/)) {
                        optionValue = $(optionValue).html();
                    }

                    options[option] = optionValue;
                }
            });
        }

        // default options
        options = $.extend({
            focusButton: 'validate',
            title: '',
            doubleConfirm: false,
            message: __('global.warning.confirm'),
            textButton: __('global.word.ok'),
            cancelButton: false,
            textButtonCancel: __('global.word.cancel'),
            cancelCallback: $.noop,
            confirmCallback: $.noop,
        }, options);

        element = confirmTemplate({
            title: options.title,
            doubleConfirm: options.doubleConfirm,
            icon: options.icon,
            text: options.message,
        });

        dialogOptions = {
            closeText: __('global.action.close_button'),
            closeOnEscape: true,
            draggable: false,
            resizable: false,
            modal: true,
            buttons: [],
            open: function (event) {
                onOpen($(this), options.textButton, options.doubleConfirmButton, options.focusButton);
            },
            width: (responsive.getCurrentWidth() !== 'small' && typeof options.forceWidth !== 'undefined') ? options.forceWidth : 300,
            close: function (event) {
                $currentWin = null;
                $(window).off('scroll resize mousewheel', onScrollResize).off('click', onClickOutside);

                if (!$element.data('confirmed')) {
                    options.cancelCallback(event);
                }
                $element.data('confirmed', false);

                $(this).dialog('destroy').remove();
            },
        };

        $element = $(element);

        if (options.cancelButton) {
            dialogOptions.buttons.push({
                text: options.textButtonCancel,
                create: function () {
                    $(this).addClass('cancel-button  js-cancel-button');
                },
                click: function () {
                    $(this).dialog('close');
                },
            });
        }

        dialogOptions.buttons.push({
            text: options.textButton,
            create: function () {
                $(this).addClass('validate-button js-validate-button');
            },
            click: function (event) {
                var doubleConfirm = !!options.doubleConfirm, $doubleCheck, checked;

                if (options.doubleConfirm) {
                    $doubleCheck = $(this).find('.js-confirm-doubleCheck');
                    checked = $doubleCheck.prop('checked');
                }

                if (!doubleConfirm || (doubleConfirm && checked)) {
                    if (typeof options.confirmCallback === 'function') {
                        options.confirmCallback(event);

                        // assume we pass an url...
                    } else {
                        window.location = options.confirmCallback;
                    }

                    $element.data('confirmed', true);
                }

                $(this).dialog('close');
            },
        });

        $currentWin = $element.dialog(dialogOptions);

        $(window).on('scroll resize mousewheel', onScrollResize).on('click', onClickOutside);
    }

    return {
        init: function () {

            var // get elements we flagged to be confirmed
                $confirms = $('.js-confirm'),

                // final elements to put the event on (sometimes we can put the js-confirm class
                // to an element, but have to add event to it's parent)
                elementArray = [],

                handleOpening = function (event, confirmed) {
                    var $elm = $(this), undoValue = $elm.data('undo-value');

                    if (!confirmed) {
                        event.preventDefault();
                        event.stopImmediatePropagation();

                        confirm({
                            element: this,
                            confirmCallback: function () {
                                $elm.data('undo-value', $elm.val());
                                if ($elm.is('a')) {
                                    window.location = $elm.attr('href');
                                } else {
                                    $elm.trigger(event.type, [true]);
                                }

                                $elm.closest('.oc-form').addClass('oc-form--loading').prepend('<div class="oc-form__overlay"></div>').wrapInner('<div class="oc-form__inner"></div>');
                            },

                            cancelCallback: function () {
                                if (undoValue) {
                                    $elm.val(undoValue);
                                }
                            },
                        });
                    }
                };

            $confirms.each(function (n, element) {
                var closestForm, $element = $(element);

                // keep current value for select, in case of revert
                if ($element.is('select')) {
                    $element.data('undo-value', $element.val());
                }

                if ($element.is('[type=submit]')) {
                    closestForm = $element.closest('form').get(0);
                    $element.removeClass('js-confirm');
                    $(closestForm).data($element.data()).addClass('js-confirm');

                    // keep the closest form in this case
                    elementArray.push(closestForm);
                } else {
                    elementArray.push(element);
                }

                const openOnChange = $element.data('open-on-change');
                if (typeof openOnChange === 'boolean' && openOnChange !== false) {
                    $(closestForm).attr('data-open-on-change', 'true');
                }
            });

            $(document)
                .on('click', 'a.js-confirm', handleOpening)
                .on('change', '.js-confirm[data-open-on-change="true"]', handleOpening)
                .on('submit', '.js-confirm', handleOpening);

        },

        show: confirm,

        alert: alert,

        injectTranslator: function (translator) {
            __ = translator;
        },
    };
});
